/**
 * Profile constants for BYI role definitions
 * Direct 1:1 mapping with old system roles for perfect compatibility
 */

export const PROFILES = {
  // Role-based profiles (what they can do)
  OPERATOR: "BYI Operator", // = billetyardinv_read_operate
  SUPERVISOR: "BYI Supervisor", // = billetyardinv_read_supervise
  MES_SUPERVISOR: "BYI-MES Supervisor", // = MESBYISupervisorRole
  READ_ONLY: "BYI Read Only", // New (view-only access)

  // Access mode profiles (how they access the system)
  TOUCH_ACCESS: "BYI Touch Access", // = DisplayedOnMES=0 behavior
  MES_ACCESS: "BYI MES Access", // = DisplayedOnMES=1 behavior
} as const;
